<template>
  <div class="answers">
    <div class="edit-answer-group w-11/12 flex flex-wrap" v-if="active">  
      <markdown-editor class="w-full answer-field" ref="markdownEditor" v-model="answer.content_md" :options="{hideModeSwitch:true,previewStyle:'tab'}" height="200px" />
      <div class="flex w-full justify-between mt-3">
        <div class="flex w-1/3">
          <vs-switch label="some" v-model="answer.is_correct" :checked="answer.is_correct" class="mr-3 answer-is-correct" />
          <label>Is a correct answer</label>
        </div>
        <div class="flex w-1/3">
          <vs-switch label="some" v-model="answer.stick_to_bottom" :checked="answer.stick_to_bottom" class="mr-3 answer-is-correct" />
          <label>Stick to bottom</label>
        </div>
        <div>
          <vs-button class="mt-3 mr-5 save-button" color="primary" type="filled" icon-pack="feather" @click.stop="finishAndClose">Save</vs-button>
          <vs-button class="mt-3 cancel-button" color="primary" type="border" icon-pack="feather" @click.stop="closeEdition">Cancel</vs-button>
        </div>
      </div>
    </div>
    <div class="view-answer-group" ref="answercontent" v-else>
      <div class="view-answer flex justify-end">
        <div 
          :class="`w-full cursor-pointer p-4 border border-solid rounded border-grey-light answer-content ${answer.is_correct ? 'correct-answer' : ''}`"
          @click.stop="active = true"
        >
          <prism-markdown :content="answer.content_md || 'empty answer'" />
        </div>
        <div class="p-4 cursor-pointer delete-answer" @click.stop="$emit('delete-answer', {answerId: index})" title="Delete answer"><feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 color-current text-danger"/></div>
      </div>
    </div>
  </div>
</template>
<script>
import MarkdownEditor from '@/components/markdownEditor'
import PrismMarkdown from '@/components/PrismMarkup'

export default {
  components: {
    MarkdownEditor,
    PrismMarkdown
  },
  props: {
    answer: Object,
    index: [String, Number]
  },
  data: () => {
    return {
      active: false
    }
  },
  methods: {
    finishAndClose () {
      this.$emit('finish-edit-answer', {
        answer: this.answer,
        index: this.index
      })
      this.active = false
    },
    closeEdition () {
      this.active = false
    },
    updatePrism() {
      this.$nextTick().then(() => {
        if (this.$refs.answercontent) {
          if (window.MathJax) {
            window.MathJax.Hub.Config({
              tex2jax: {
                inlineMath: [['$', '$']],
                displayMath: [['$$', '$$']],
                processEscapes: true,
                processEnvironments: true,
              },
              // Center justify equations in code and markdown cells. Elsewhere
              // we use CSS to left justify single line equations in code cells.
              displayAlign: 'center',
              'HTML-CSS': {
                styles: { '.MathJax_Display': { margin: 0 } },
                linebreaks: { automatic: true },
              },
            })
            window.MathJax.Hub.Queue([
              'Typeset',
              window.MathJax.Hub,
              this.$refs.answercontent,
            ])
          }
        }
      })
    },
  },
  mounted() {
    this.active = !this.answer.id
  },
  watch: {
    active(newValue) {
      if (!newValue)
        this.updatePrism()
    }
  }
}
</script>
<style lang="scss">
.answers {
  .correct-answer {
    border: 1px solid #24ca50 !important;
  }
}
</style>